import React from 'react'
import { connect } from 'react-redux'
import { Form, Input, Button,Spin,Card,Avatar,Anchor,BackTop,Affix,Image } from 'antd';
import { UserOutlined, LockOutlined, LoadingOutlined, PhoneFilled, PhoneOutlined, MessageOutlined, MailOutlined, BankOutlined } from '@ant-design/icons';
import { NavLink } from 'react-router-dom'
import { withRouter } from 'react-router-dom';
import axios from 'axios'
import { Layout, Menu, Breadcrumb,Carousel,Tabs,Collapse } from 'antd';
import {
  Col,
  Row,
} from 'reactstrap';

const { Header, Content, Footer } = Layout;

const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

const { TabPane } = Tabs;
const { Panel } = Collapse;
const { Meta } = Card;

const contentStyle = {
  //height: '200px',
  color: '#fff',
  lineHeight: '200px',
  //textAlign: 'center',
  background: '#BEBBB9',
  padding:5,
  //borderRadius:30
};

const style = {
  height: 40,
  width: 40,
  lineHeight: '40px',
  borderRadius: 4,
  backgroundColor: '#FD7B15',
  color: '#fff',
  textAlign: 'center',
  fontSize: 14,
};

class PrivacyPolicyUmotrack extends React.Component {

  state = {


  }


  render(){

      return (
        <div>
      

          <Card style={{borderRadius:6}}>

  <h1>Privacy Policy</h1>
  <p><strong>Effective Date:</strong> 2024-06-10</p>

  <p>Umoja Integrated Medical Couriers Ug Ltd built the UmoTrack app as a Commercial app. This SERVICE is provided by Umoja Integrated Medical Couriers Ug Ltd and is intended for use as is.</p>

  <p>This page is used to inform visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decides to use our Service.</p>

  <p>If you choose to use our Service, then you agree to the collection and use of information in relation to this policy. The Personal Information that we collect is used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy.</p>

  <p>The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which are accessible at UmoTrack unless otherwise defined in this Privacy Policy.</p>

  <h2>Information Collection and Use</h2>
  <p>For a better experience, while using our Service, we may require you to provide us with certain personally identifiable information, including but not limited to your phone contact, email address, and location data. The information that we request will be retained by us and used as described in this privacy policy.</p>

  <p>The app does use third-party services that may collect information used to identify you.</p>
  <p>Link to privacy policy of third-party service providers used by the app:</p>
  <ul>
    <li><a href="https://www.google.com/policies/privacy/" target="_blank">Google Play Services</a></li>
  </ul>

  <h2>Location Information</h2>
  <p>Our app may collect and use <strong>location data</strong> to provide key features of the Service, such as real-time tracking, delivery status updates, and route optimization. This data may be collected in the foreground or background, depending on how the app is used.</p>

  <p>We collect this information for the following purposes:</p>
  <ul>
    <li>To enable accurate delivery tracking and route management</li>
    <li>To ensure timely and secure medical courier services</li>
    <li>To optimize delivery logistics and improve service quality</li>
  </ul>

  <p>Location data may be shared with third-party services only to perform services on our behalf (such as map services or analytics) and will never be sold or used for unrelated purposes.</p>

  <p>You can manage or revoke location access at any time via your device settings. Note that disabling location services may impact the functionality of the app.</p>

  <h2>Log Data</h2>
  <p>We want to inform you that whenever you use our Service, in a case of an error in the app we collect data and information (through third-party products) on your phone called Log Data. This Log Data may include information such as your device Internet Protocol (“IP”) address, device name, operating system version, the configuration of the app when utilizing our Service, the time and date of your use of the Service, and other statistics.</p>

  <h2>Cookies</h2>
  <p>Cookies are files with a small amount of data that are commonly used as anonymous unique identifiers. These are sent to your browser from the websites that you visit and are stored on your device's internal memory.</p>

  <p>This Service does not use these “cookies” explicitly. However, the app may use third-party code and libraries that use “cookies” to collect information and improve their services. You have the option to either accept or refuse these cookies and know when a cookie is being sent to your device. If you choose to refuse our cookies, you may not be able to use some portions of this Service.</p>

  <h2>Service Providers</h2>
  <p>We may employ third-party companies and individuals due to the following reasons:</p>
  <ul>
    <li>To facilitate our Service</li>
    <li>To provide the Service on our behalf</li>
    <li>To perform Service-related services</li>
    <li>To assist us in analyzing how our Service is used</li>
  </ul>

  <p>We want to inform users of this Service that these third parties have access to their Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.</p>

  <h2>Security</h2>
  <p>We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.</p>

  <h2>Links to Other Sites</h2>
  <p>This Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.</p>

  <h2>Children’s Privacy</h2>
  <p>These Services do not address anyone under the age of 13. We do not knowingly collect personally identifiable information from children under 13 years of age. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we can take necessary action.</p>

  <h2>Changes to This Privacy Policy</h2>
  <p>We may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page.</p>

  <h2>Contact Us</h2>
  <p>If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us at:</p>
  <p><strong>Email:</strong> <a href="mailto:info4rmumojaimcouriers@gmail.com">info4rmumojaimcouriers@gmail.com</a></p>


            </Card>


        </div>
        );
  }
}



export default PrivacyPolicyUmotrack;
